module.exports = __webpack_public_path__ + "static/profile-f3a3bda4e361f0c4400d41a60f3f811c.jpg";